import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains, getProgramLevelDomainForSchooling } from '../../../../library/Service/domainService';
import { handleNext } from './SchoolHigherStudiesActions';
import SchoolHigherStudiesLayout from './SchoolHigherStudiesLayout';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';
import formConfig from './PageConfigSchoolHigherStudied.json';

const SchoolHigherStudies = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

    const levels = Array.from({ length: 13 }, (_, index) => index + 1).map(number => ({
        label: number.toString(),
        value: number
    }));
    const [programLevel, setprogramLevel] = useState(getProgramLevelDomainForSchooling('PROGRAM_LEVEL', levels));

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { NEXT: handleNext, ROUTER_NAVIGATE: navigate, REDIRECT: setRedirectUrl },
    } as any);

    const { data, internal, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        console.log('school redirect -=--=-=-=-=-=-=-=-=-=--=-=-')
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    useEffect(() => {
        data['schools'] = data['schools'] || {};
        const domainMap = new Map([...globalState.domain]);
        // domainMap.set('INSTITUTE_PROGRAM_CODE', internal);
        domainMap.set('PROGRAM_LEVEL_SCHOOL', programLevel);
        const domain = addUserSpecificDomains(new Map([...domainMap]), data);
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, routeInfo },
        });
    }, []);

    let message = `Since you mentioned you are currently Pursuing Higher Studies, please provide the details.`
    let outcomeStudiesStatus = ['HIGHER_STUDIES','WENT_FOR_HIGHER_STUDIES','JOINED_UG']
    if(outcomeStudiesStatus.includes(state?.data?.selectedInstitute?.postProgramCompletionStatusCode)){
        let program_name = getDomainValueForCode(state?.data?.selectedInstitute?.programId,'ALL_PROGRAM_CODE',state)
        message =`After ${program_name}, you mentioned that you went for higher studies. Please provide the details.`
    }
    else 
    if(state?.data?.profile?.presentEducationStatusCode == "PURSUING_STUDIES"){
        let program_level = state?.data?.profile?.pursuingEducationLevelCode
        message = `In your education status, you mentioned that you are currently pursuing studies at ${program_level} level. Please provide the details of your current education.`
    }

    return (
         <SmartContext.Provider value={{ state, dispatch }}>
            <SchoolHigherStudiesLayout> {!state.flags.isDataLoading && <PageBuilder data={message} />}</SchoolHigherStudiesLayout>
        </SmartContext.Provider>
    );
};

export default SchoolHigherStudies;
